<template>
  <div class="prvd__bg" v-if="false">
    <div class="prvd__modal">
      <div class="prvd__top">
        <img src="/static/img/gus_2.svg" class="prvd__conf prvd__conf__1">
        <img src="/static/img/gus_1.svg" class="prvd__conf prvd__conf__2">
        <div class="conf__dot prvd__conf prvd__conf__3"></div>
        <div class="conf__smallring prvd__conf prvd__conf__4"></div>
        <div class="conf__dot prvd__conf prvd__conf__5"></div>
        <div class="conf__dot prvd__conf prvd__conf__6"></div>
        <div class="conf__bigring prvd__conf prvd__conf__7"></div>
        <img src="/static/img/gus_2.svg" class="prvd__conf prvd__conf__8">
        <p class="prvd__prelude">Ты получил:</p>
        <div class="prvd__reward">
          <p class="prvd__val">15</p>
          <p class="prvd__word">Баллов</p>
        </div>
        <div class="popup__progress">
          <div class="popup__progress__top">
            <p class="popup__progress__currentlvl">2 Уровень</p>
            <p class="popup__progress__lvlprogress"><span>20</span> / 40 баллов</p>
          </div>
          <div class="popup__progress__bar__container">
            <div class="popup__progress__bar"></div>
          </div>
        </div>
      </div>
      <div class="popup__bottom">
        <p class="popup__bottom__about">
          <span class="popup__bottom__link">Подробнее о программе лояльности</span>
        </p>
        <div class="popup__bottom__button">Закрыть</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {}
</script>




// WEBPACK FOOTER //
// points-received.vue?7fa0cc05